import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

export default function AdminInvoiceEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    loadInvoice();
  }, [id]);

  async function loadInvoice() {
    try {
      setLoading(true);

      const { data, error } = await supabase
        .from("invoices")
        .select("*")
        .eq("id", id)
        .single();

      if (error) throw error;

      setInvoice(data);
    } catch (err) {
      console.error(err);
      alert("Erreur chargement facture");
    } finally {
      setLoading(false);
    }
  }

  async function saveInvoice() {
    try {
      setSaving(true);

      const { error } = await supabase
        .from("invoices")
        .update({
          recipient_name: invoice.recipient_name,
          recipient_email: invoice.recipient_email,
          recipient_address: invoice.recipient_address,
          notes: invoice.notes,
          status: invoice.status,
        })
        .eq("id", id);

      if (error) throw error;

      alert("Facture mise à jour !");
      navigate(`/admin/factures/${id}`);
    } catch (err) {
      console.error(err);
      alert("Erreur mise à jour");
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <p>Chargement...</p>;
  if (!invoice) return <p>Facture introuvable</p>;

  return (
    <div style={{ padding: "40px", color: "#fff", background: "#0b1020", minHeight: "100vh" }}>
      <h1>Modifier la facture</h1>

      <div style={{ marginTop: "20px" }}>
        <label>Client</label>
        <input
          value={invoice.recipient_name || ""}
          onChange={(e) =>
            setInvoice({ ...invoice, recipient_name: e.target.value })
          }
        />
      </div>

      <div>
        <label>Email</label>
        <input
          value={invoice.recipient_email || ""}
          onChange={(e) =>
            setInvoice({ ...invoice, recipient_email: e.target.value })
          }
        />
      </div>

      <div>
        <label>Adresse</label>
        <textarea
          value={invoice.recipient_address || ""}
          onChange={(e) =>
            setInvoice({ ...invoice, recipient_address: e.target.value })
          }
        />
      </div>

      <div>
        <label>Statut</label>
        <select
          value={invoice.status}
          onChange={(e) =>
            setInvoice({ ...invoice, status: e.target.value })
          }
        >
          <option value="draft">Brouillon</option>
          <option value="sent">Envoyée</option>
          <option value="paid">Payée</option>
        </select>
      </div>

      <div>
        <label>Notes</label>
        <textarea
          value={invoice.notes || ""}
          onChange={(e) =>
            setInvoice({ ...invoice, notes: e.target.value })
          }
        />
      </div>

      <button onClick={saveInvoice} disabled={saving}>
        {saving ? "Enregistrement..." : "Enregistrer"}
      </button>
    </div>
  );
}